/* tslint:disable */

/**
 */
export class RpOutputView {
    count_ticket_total?: number;
    station_start?: string;
    ended?: string;
    sign?: string;
    start_number?: number;
    end_number?: number;
    started?: string;
    count_ticket_month?: number;
    count_ticket_free?: number;
    count_ticket_student?: number;
    count_ticket_worker?: number;
    count_ticket_qrcode?: number;
    count_ticket_charge?: number;
}
